import {createSelector} from 'reselect';

const options = (state) => state.designChapter.currentView.options;

export const getDesignChapterOptions = createSelector(
  [options],
  (options) => options
);

const viewType = (state) => state.designChapter.currentView.viewType;

export const getViewTypeForStepOptions = createSelector(
  [viewType],
  (viewType) => viewType
);
